import styled from 'styled-components';
import loginBg from '@/assets/loginBg.svg';
import { media } from '@/styles/responsive';

export const Grid = styled.div`
  width: 100vw;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  overflow-x: hidden;

  ${media.mobile} {
    grid-template-columns: 1fr;
  }
`;

export const Title = styled.h1`
  font-size: 140px;
  font-weight: 700;
  line-height: 148.4px;
  color: ${(props) => props.theme.colors['primary-60']};
  margin-bottom: 40px;
`;

export const SubTitle = styled.h2`
  font-size: 42px;
  font-weight: 300;
  line-height: 48px;
  color: ${(props) => props.theme.colors['neutral-100']};
  padding-right: 80px;
  margin-bottom: 163px;
`;

export const FormTitle = styled.h3`
  font-size: 26px;
  font-weight: 700;
  line-height: 30px;
  color: ${(props) => props.theme.colors['neutral-100']};
  margin-bottom: 24px;
`;

export const Paragraph = styled.p`
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
  color: ${(props) => props.theme.colors['neutral-100']};
`;

export const Img = styled.img`
  display: block;
  width: 52px;
  margin-bottom: 24px;
`;

export const ContentContainer = styled.div`
  padding: 84px 60px;

  ${media.mobile} {
    display: none;
  }
`;

export const ContainerSocial = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const ContainerLinks = styled.div`
  display: flex;
  gap: 14px;
`;

export const SignInContainer = styled.div`
  background-image: url(${loginBg});
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  padding: 84px 120px 45px 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 16px;

  ${media.mobile} {
    padding: 24px 20px;
    min-height: 100vh;
    min-height: 100dvh;
  }
`;

export const Card = styled.div`
  background-color: #fff;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 400px;
  padding: 40px;
  border-radius: 12px;

  ${media.mobile} {
    width: 100%;
    max-width: 400px;
    padding: 24px 20px;
  }
`;

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 24px;
`;

export const Input = styled.input.attrs((props) => ({
  placeholderTextColor: props.theme.colors['neutral-80'],
}))`
  width: 100%;
  padding: 24px;
  border: 1px solid ${(props) => props.theme.colors['neutral-40']};
  border-radius: 4px;
  margin-bottom: 16px;
  color: ${(props) => props.theme.colors['neutral-80']};
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;

  ${media.mobile} {
    padding: 16px;
    font-size: 16px;
  }
`;

export const ForgotPasswordLink = styled.a`
  display: block;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  color: ${(props) => props.theme.colors['primary-60']};
  margin-bottom: 24px;
  align-self: flex-start;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
`;

export const SignInBtn = styled.button`
  display: inline-block;
  background-color: ${(props) => props.theme.colors['primary-60']};
  border: none;
  border-radius: 4px;
  color: #fff;
  font-weight: 700;
  font-size: 16px;
  padding: 19px 24px 15px 24px;
  margin-bottom: 24px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  ${media.mobile} {
    width: 100%;
    min-height: 48px;
    padding: 14px 24px;
  }
`;

export const ExistingAccountText = styled.p`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: ${(props) => props.theme.colors['neutral-100']};
  align-self: flex-start;
  margin-bottom: 24px;
`;

export const SignUpLink = styled.span`
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  color: ${(props) => props.theme.colors['primary-60']};
`;

export const SeparatorText = styled.p`
  font-size: 16px;
  line-height: 22px;
  font-weight: 700;
  color: ${(props) => props.theme.colors['neutral-40']};
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  width: 100%;

  &::before {
    content: '';
    display: inline-block;
    border: 1px solid ${(props) => props.theme.colors['neutral-40']};
    flex: 1;
    margin-right: 10px;
  }

  &::after {
    content: '';
    display: inline-block;
    border: 1px solid ${(props) => props.theme.colors['neutral-40']};
    flex: 1;
    margin-left: 10px;
  }
`;

export const GoogleBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  font-size: 16px;
  line-height: 22px;
  font-weight: 700;
  background: transparent;
  color: ${(props) => props.theme.colors['neutral-80']};
  border: 1px solid ${(props) => props.theme.colors['neutral-80']};
  border-radius: 4px;
  padding: 20px;
  width: 100%;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  ${media.mobile} {
    min-height: 48px;
    padding: 14px 20px;
  }
`;

export const ErrorMessageBox = styled('div')<{ type: string }>`
  width: 100%;
  background-color: ${({ type }) => (type === 'success' ? '#2AD062' : '#EF5B5B')}};
  color: white;
  text-align: center;
  margin: 20px;
  padding: 20px 5px;
  border-radius: 5px;
`;

export const LegalLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 24px;
  font-size: 12px;
  color: #71717A;

  a {
    color: #71717A;
    text-decoration: none;
    transition: color 200ms cubic-bezier(0.2, 0.8, 0.4, 1);

    &:hover {
      color: #054AD9;
    }

    &:active {
      color: #054AD9;
    }
  }

  span {
    color: #D4D4D8;
  }
`;
